import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";
const https = require('https');

var API_URL = config.BASE_URL + '/blockchain/'
if(process.env.NODE_ENV == "production"){
  API_URL = config.BASE_URL + '/blockchain/'
}

const agent = new https.Agent({  
    rejectUnauthorized: false
});

export const Report_blockchain_service = {
    getBlockchainTransaction,
    checkTransection,
    checkData
};

function getBlockchainTransaction(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "report_blockchain/getBlockchainTransaction/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function checkTransection(txn) {
    let blockchain_url = API_URL
    return new Promise((resolve, reject) => {
        axios.post(blockchain_url + 'checkTransection', txn, { httpsAgent: agent })
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function checkData(hash_data) {
    let blockchain_url = API_URL
    return new Promise((resolve, reject) => {
        axios.post(blockchain_url + 'checkData', hash_data, { httpsAgent: agent })
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}
